// extracted by mini-css-extract-plugin
export default {"icon":"WarningModal__icon-Ji0GU"};